<template>
  <el-button-icon
    :class="`v-btn-danger ${classP}`"
    icon="mdi-trash-can"
    :disabled="disabled"
    :loading="loading"
  >
    <template v-if="isSlot">
      <slot></slot>
    </template>
    <template v-else>
      Pašalinti
    </template></el-button-icon
  >
</template>

<script>
export default {
  name: 'ElButtonPasalinti',
  props: {
    classP: String,
    disabled: Boolean,
    loading: Boolean,
  },
  computed: {
    isSlot() {
      return !!this.$slots.default
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
